import type { UpholsteryCar } from "@views/Upholstery/types"
import {
  getPdmStepStructure,
  PDM_STEPS_ORDER,
} from "../../constants/step-structure"

/**
 * Minimal vehicle shell for PDM-listed cars that have no Dato `upholsteryCar`.
 * Body / rows / factory-match shells are filled by PDM merge; style steps come
 * from Steps V2 when that flag is on.
 */
export function buildSyntheticUpholsteryCar(
  make: string,
  model: string,
  year: string
): UpholsteryCar {
  return {
    id: `pdm-${slugPart(make)}-${slugPart(model)}-${slugPart(year)}`,
    make,
    model,
    years: year,
    sku: "",
    image: null,
    trims: "",
    driverFactorySeatType: "",
    passengerFactorySeatType: "",
    options: null,
    steps: PDM_STEPS_ORDER.map((key) => getPdmStepStructure(key)),
  }
}

function slugPart(value: string): string {
  return value.trim().toLowerCase().replace(/\s+/g, "-") || "unknown"
}
